import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerLinks = [
    { label: 'Início', href: '/' },
    { label: 'Guia de Compras', href: '/guia-de-compras' },
    { label: 'CSSBuy Sheet', href: 'https://kaspreadsheet.com', external: true },
  ];

  const categoryLinks = categories.slice(0, 7).map((c) => ({
    label: c.name,
    href: c.url,
    external: true,
  }));

  const moreCategoryLinks = categories.slice(7).map((c) => ({
    label: c.name,
    href: c.url,
    external: true,
  }));

  const renderLink = (link: { label: string; href: string; external?: boolean }) => {
    if (link.external) {
      return (
        <a
          href={link.href}
          target="_blank"
          rel="noopener nofollow"
          className="text-foreground-500 hover:text-foreground-950 text-xs transition-colors whitespace-nowrap cursor-pointer"
        >
          {link.label}
        </a>
      );
    }
    return (
      <a
        href={link.href}
        className="text-foreground-500 hover:text-foreground-950 text-xs transition-colors whitespace-nowrap cursor-pointer"
      >
        {link.label}
      </a>
    );
  };

  return (
    <footer className="relative w-full bg-background-200 border-t border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Brand */}
          <div className="flex-1 lg:max-w-sm">
            <h3 className="font-heading font-bold text-foreground-950 text-3xl md:text-4xl leading-tight mb-3">
              CSSBuy<br />Info
            </h3>
            <p className="text-foreground-500 text-xs leading-relaxed mb-6">
              O melhor diretório de CSSBuy Spreadsheet do Brasil. Produtos verificados, links atualizados e a melhor curadoria de streetwear.
            </p>
            <p className="text-foreground-400 text-xs">
              Atualizado em Junho de 2026
            </p>
          </div>

          {/* Right - Link Columns */}
          <div className="flex-1 grid grid-cols-3 gap-8">
            {/* Column 1 */}
            <div className="flex flex-col gap-3">
              <h4 className="text-foreground-950 font-semibold text-xs mb-1">Navegação</h4>
              {footerLinks.map((link, idx) => (
                <div key={idx}>{renderLink(link)}</div>
              ))}
            </div>

            {/* Column 2 */}
            <div className="flex flex-col gap-3">
              <h4 className="text-foreground-950 font-semibold text-xs mb-1">Categorias</h4>
              {categoryLinks.map((link, idx) => (
                <div key={idx}>{renderLink(link)}</div>
              ))}
            </div>

            {/* Column 3 */}
            <div className="flex flex-col gap-3">
              <h4 className="text-foreground-950 font-semibold text-xs mb-1">Mais Categorias</h4>
              {moreCategoryLinks.map((link, idx) => (
                <div key={idx}>{renderLink(link)}</div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 CSSBuy Info. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="/" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">Privacidade</a>
            <a href="/" className="text-foreground-400 hover:text-foreground-600 text-xs transition-colors cursor-pointer">Termos</a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-400 hover:text-accent-500 text-xs transition-colors cursor-pointer"
            >
              Kaspreadsheet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}